import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#3126AD",
    "fill-rule": "evenodd",
    d: "M2.72 12.957v-.434c0-5.176 4.203-9.378 9.378-9.378 5.176 0 9.378 4.202 9.378 9.378v.434l-3.263.816a2.626 2.626 0 0 0-1.988 2.547v4.654c0 1.307.96 2.415 2.254 2.6l2.25.321a2.627 2.627 0 0 0 2.998-2.6v-8.772c0-6.418-5.21-11.628-11.629-11.628C5.681.895.47 6.105.47 12.523v8.773a2.626 2.626 0 0 0 2.997 2.6l2.25-.322a2.626 2.626 0 0 0 2.255-2.6V16.32c0-1.205-.82-2.255-1.989-2.547z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      fill: "#fff",
      transform: "translate(0 .5)"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }